import React from 'react';
import ApolloErrorReducer from './ApolloErrorReducer';
import { createEventEmitter } from './EventEmitter';
import ApolloErrorNotifier from './ApolloErrorNotifier';
import ApolloErrorActions from './ApolloErrorActions';
import ApolloErrorLink from './ApolloErrorLink';

export const createApolloErrorNotifier = (errorCallback) => {
  const emitter = createEventEmitter();

  const errorLink = new ApolloErrorLink(emitter, errorCallback);

  const InitializedApolloErrorNotifirer = props => (
    <ApolloErrorNotifier {...props} apolloErrorEmitter={emitter} />
  );

  return {
    errorLink,
    ApolloErrorNotifier: InitializedApolloErrorNotifirer,
    ApolloErrorReducer,
  };
};

export { ApolloErrorActions };

export default {
  ApolloErrorReducer,
  ApolloErrorNotifier,
  ApolloErrorActions,
  ApolloErrorLink,
  createEventEmitter,
  createApolloErrorNotifier,
};
